import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { testimonials } from "../../data/content";
export function TestimonialsSection() {
  return <section className="bg-mist px-5 py-16 sm:py-20" data-id="element-296" data-mp="1rtl3v9mmsc7a">
      <div className="mx-auto max-w-6xl" data-id="element-297" data-mp="1mvjnwxki4t01">
        <SectionHeading kicker="What dental professionals are saying" title="Discover How Professionals Are Using the DENTAL BLEACHING BLUEPRINT™" data-id="element-298" data-mp="1muiaimg0juf5" />
        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-299" data-mp="1dubqsitq1y7j">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_-18px_rgba(10,31,68,0.4)]" data-id="element-300" data-mp="18x20l0yidiin">
              <div className="flex items-center gap-4" data-id="element-301" data-mp="33akwk6cw4t1u">
                <img src={t.photo} alt={t.name} className="h-[72px] w-[72px] shrink-0 rounded-full object-cover ring-4 ring-brand-soft" data-id="element-302" data-mp="33a1p5jkv9n22" />
                <div data-id="element-303" data-mp="1t9n80dhekaj5">
                  <p className="flex items-center gap-1.5 font-display text-[17px] font-black text-navy-950" data-id="element-304" data-mp="1t9do97myazlw">
                    {t.name}
                    <BadgeCheckIcon className="h-[18px] w-[18px] shrink-0 text-brand" aria-label="Verified buyer" data-id="element-305" data-mp="1ya1g1vj07kh6" />
                  </p>
                  <p className="text-[14px] font-medium text-muted" data-id="element-306" data-mp="1oaai1jv8incc">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-307" data-mp="1ocdikxu0jyvb">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-308" data-mp="2gy6ecngw6d8l" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote className="mt-5 text-[16px] leading-relaxed text-ink" data-id="element-309" data-mp="278mtjc9mc9b3">“{t.quote}”</blockquote>
            </figure>)}
        </div>
        <SectionCta label="Get the complete clinical library for $27" note="Join the professionals already using the Blueprint" data-id="element-310" data-mp="2uwwa9zrz66vd" />
      </div>
    </section>;
}